<template>
  <div class="border border-grey p-6 md:w-1/3 w-full m-4">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AdminPanel'
}
</script>
